import { createRequest } from '@shared/services';

export async function getAddressForm(args: GetCartAddressFormParams) {
    const request = createRequest<GetCartAddressFormResponse>({
        url: '/address/address-form',
        method: 'GET',
        withAuthorization: true,
        params: args,
    });

    return request.execute();
}

export async function postAddressAutocomplete(data: PostCartAddressAutocompletePayload) {
    const request = createRequest<
        PostCartAddressAutocompleteResponse | PostCartAddressTwCVSAutocompleteResponse
    >({
        url: '/address/auto-complete',
        method: 'POST',
        withAuthorization: true,
        data,
    });

    return request.execute();
}

export async function getAddressBook(args: GetCartAddressBookParams) {
    const request = createRequest<GetCartAddressBookResponse>({
        url: '/address/address-book',
        method: 'GET',
        withAuthorization: true,
        useToastHandler: false,
        params: args,
    });

    return request.execute();
}

export async function putAddressBook(data: PutCartAddressBookPayload) {
    const request = createRequest<PutCartAddressBookResponse>({
        url: '/address/address-book',
        method: 'PUT',
        withAuthorization: true,
        data,
    });

    return request.execute();
}

export async function getAddressCountry() {
    const request = createRequest<GetCartAddressCountryResponse>({
        url: '/address/country',
        method: 'GET',
    });

    return request.execute();
}

export async function getAddressPhoneCode() {
    const request = createRequest<GetCartAddressPhoneCodeResponse>({
        url: '/address/phone-code',
        method: 'GET',
    });

    return request.execute();
}
